import { safeWindow } from "framer-motion"

// const performance = safeWindow.performance || {
//   offset: Date.now(),
//   now: () => Date.now() - this.offset
// };

const _raf = (f: FrameRequestCallback) => {
    setTimeout(f, 1 / 60)
}
const __raf = safeWindow["requestAnimationFrame"] || _raf

export const raf = (f: Function) => __raf(f as FrameRequestCallback)
